import React, { useState, useContext } from 'react';

import EditUserAccountPassword from './EditUserAccountPassword';
import { Link } from 'react-router-dom';
import { Button } from 'antd';

// import { changeDefaults } from 'services/login';


import { AppContext } from 'context/AppContext';

const UserDetailsAccount = (props) => {
    let appContext = useContext(AppContext);

    const [visibleEditPassword, setVisibleEditPassword] = useState(false);

    const showDrawerEditPassword = () => {
        setVisibleEditPassword(true);
    };

    const onCloseEditPassword = () => {
        setVisibleEditPassword(false);
    };

    // const relunchOnboarding = async ()=>{
    //     let send1 = await changeDefaults(Number(sessionStorage.getItem('onboarding_home')),{name:'onboarding_home', value:'true'});
    //     let send2 = await changeDefaults(Number(sessionStorage.getItem('onboarding_project')),{name:'onboarding_project', value:'true'});
    //         return send1, send2, window.location.reload(true);
    // }

    return (
        <>
            <div className="account-details-container">
                <div className="account-details-box">
                    <div>
                        First Name:{' '}
                        <span>{appContext.defaults.first_name}</span>
                    </div>
                    <div>
                        Last Name: <span>{appContext.defaults.last_name}</span>
                    </div>
                    <div>
                        Username: <span>{appContext.defaults.username}</span>
                    </div>

                    <div style={{ marginBottom: '15px' }}>
                        Email: <span>{appContext.defaults.email}</span>
                    </div>
                    {/* <div className="more-options" onClick={showDrawer}>
                        Edit Details
                    </div> */}
                    <div
                        className="more-options"
                        onClick={() => {
                            props.showDrawerEditAccount();
                        }}
                    >
                        Edit Details
                    </div>
                    <div
                        className="more-options"
                        onClick={showDrawerEditPassword}
                    >
                        Change Password
                    </div>

                    {appContext.defaults.is_staff ? (
                        <>
                            <div
                                onClick={() => {
                                    appContext.setMainUserDetailsDrawerIsVisible(
                                        false
                                    );
                                }}
                            >
                                <Link
                                    to={`/add-help`}
                                    style={{ textDecoration: 'none' }}
                                >
                                    <div
                                        className="more-options"
                                        style={{ marginTop: 15 }}
                                    >
                                        Manage Help
                                    </div>
                                </Link>
                            </div>
                            {/* <div className='more-options' onClick={()=>{ relunchOnboarding()}}>Relunch Onboarding</div> */}
                        </>
                    ) : null}
                </div>
            </div>

            {visibleEditPassword && (
                <EditUserAccountPassword
                    visibleEditPassword={visibleEditPassword}
                    setVisibleEditPassword={setVisibleEditPassword}
                    showDrawerEditPassword={showDrawerEditPassword}
                    onCloseEditPassword={onCloseEditPassword}
                />
            )}
        </>
    );
};

export default UserDetailsAccount;
